import styled from 'styled-components';

export const GuessesWrapper = styled.div`
  padding: 8px;
  background-color: #111111;
`;
